(function () {
    "use strict";

    angular.module("app").controller("AssistanceInListController", AssistanceInListController);

    AssistanceInListController.$inject = [
        "controllerDecorator", "utils", "assistanceInService",
        "securityCheck", "PersonCheckDialogContext", "assistanceInList",
    ];
    function AssistanceInListController(controllerDecorator, utils, assistanceInService, securityCheck, PersonCheckDialogContext, assistanceInList) {
        const store = {
            listId: null,
            foreignPartners: [],
        };

        const vm = this;
        controllerDecorator.Decorate(vm, []);

        vm.isLoading = true;
        vm.handlePerson = handlePerson;

        vm.selectedItems = [];
        vm.onSelectAll = onSelectAll;
        vm.bulkAnswerChecks = bulkAnswerChecks;

        vm.downloadExcel = downloadExcel;
        vm.personFilter = personFilter;

        activate();

        function activate() {

            // Initial load
            const parsed = vm.ParsePrettyUrl();
            store.listId = parsed.id;

            loadList();
        }

        function loadList() {
            securityCheck.GetForwardedList(
                store.listId,
                r => {
                    vm.Model = r.data;
                    vm.Model.SecurityChecksToComplete.forEach(assistanceInService.addForeignPartnerInfo);
                    vm.Model.SecurityChecksToComplete.forEach(addSearchValues);
                    updateLoadingState();
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        function handlePerson(person) {

            PersonCheckDialogContext.openDialog(person).then(onSubmit, onCancel);
            function onSubmit(handledPerson) {
                const personBeingHandled = getPersonBeingHandled();

                Object.assign(personBeingHandled, handledPerson);

                securityCheck.SaveSecurityCheckResult(
                    { AssistanceInRequestPersonId: personBeingHandled.PublicId, Result: personBeingHandled.SecurityCheckResult, },
                    () => {
                        utils.removeObject(vm.Model.SecurityChecksToComplete, personBeingHandled);
                    },
                    vm.ShowError,
                    angular.noop
                );
            }

            function onCancel() {
                const personBeingHandled = getPersonBeingHandled();
                delete personBeingHandled.IsHandling;
            }

            function getPersonBeingHandled() {
                return vm.Model.SecurityChecksToComplete.find(p => p.IsHandling);
            }
        }

        function downloadExcel() {
            vm.SetLoadingState(true);

            assistanceInList.DownloadExcel(
                vm.Model.PublicId,
                angular.noop,
                vm.ShowError,
                () => vm.SetLoadingState(false),
                { responseType: "arraybuffer", }
            );
        }

        function updateLoadingState() {
            return store.foreignPartners.length === 0 || !vm.Model;
        }

        function onSelectAll(newState) {
            if (newState)
                vm.selectedItems = vm.Model.SecurityChecksToComplete.map(request => request.PublicId);
            else
                vm.selectedItems = [];
        }

        function bulkAnswerChecks() {
            vm.SetLoadingState(true);

            securityCheck.BulkComplete(
                { AssistanceInRequestPersonIds: vm.selectedItems },
                loadList,
                vm.ShowError,
                angular.noop
            );
        }

        function addSearchValues(person) {
            person.searchValues = [normalizeUnicode(person.Name), normalizeUnicode(person.FirstNames),].join(" ");
        }

        function personFilter(person) {
            if (!vm.searchText || vm.searchText.trim().length === 0)
                return true;

            // Normalize and split search words
            const needles = normalizeUnicode(vm.searchText).match(/\S+/g) || [];

            if (needles.length === 0)
                return true;

            for (const needle of needles) {
                if (!person.searchValues.includes(needle))
                    return false;
            }

            return true;
        }

        /**
         * Normalizes unicode in such a way that we can search using latin characters.
         * � is decomposed into A\u0308 after which we strip \u0308 using string.prototype.replace(RegExp, string)
         * @param {any} text
         * @returns
         */
        function normalizeUnicode(text) {
            if (!text || text.trim().length === 0)
                return "";

            return (text || "")
                .normalize("NFD")
                .replace(/\p{Diacritic}/gu, "")
                .toLowerCase();
        }
    }
})();
